module.exports = __webpack_public_path__ + "img/lb.107c3be9.svg";